import ReactApexChart from 'react-apexcharts'
import { useParams } from 'react-router-dom'
import { useStatsSingleProject } from '../../../hooks/useStatsSingleProject'
import { Alert } from 'antd'

export function RandoLine() {
  const { projectId } = useParams() as { projectId: string }
  const { projectAnalytics, barChartData } = useStatsSingleProject(projectId)

  const goals = projectAnalytics?.goals

  const randoGoal = goals && goals.length > 0 ? goals[goals.length - 1].totalRandomizations : 0

  const numEnrolled = barChartData.success[barChartData.success.length - 1]

  console.log('current randoes:', numEnrolled)

  const randoGoalPercentCompleted = Math.round((numEnrolled / randoGoal) * 100)

  const state = {
    series: [
      {
        name: 'Randomizations',
        data: [randoGoalPercentCompleted],
        color: '#DAA520',
      },
    ],
    options: {
      chart: {
        height: 50,
        type: 'bar',
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '20%',
          colors: {
            backgroundBarColors: ['#40475D'],
          },
        },
      },
      stroke: {
        width: 0,
      },
      title: {
        floating: true,
        offsetX: -10,
        offsetY: 5,
        text: 'Randomizations',
      },
      subtitle: {
        floating: true,
        align: 'right',
        offsetY: 0,
        text: `${randoGoalPercentCompleted}% (${numEnrolled}/${randoGoal})`,
        style: {
          fontSize: '20px',
        },
      },
      tooltip: {
        enabled: true,
      },
      xaxis: {
        categories: ['Randomizations'],
      },
      yaxis: {
        max: 100,
      },
      fill: {
        opacity: 1,
      },
    },
  }

  return (
    <div>
      <div>
        {/*@ts-ignore */}
        <ReactApexChart options={state.options} series={state.series} type="bar" height={50} />
        {randoGoal === 0 && <Alert type="warning" message="No randomization goal set in admin!" />}
      </div>
      <div id="html-dist-adspendchart"></div>
    </div>
  )
}
